const PLAN_I18N = {
  es: {
    demoFree: "Demo (Gratis)",
    user: ["usuario", "usuarios"],
    connection: ["conexión", "conexiones"],
  },
  en: {
    demoFree: "Demo (Free)",
    user: ["user", "users"],
    connection: ["connection", "connections"],
  },
  pt: {
    demoFree: "Demo (Grátis)",
    user: ["usuário", "usuários"],
    connection: ["conexão", "conexões"],
  },
  fr: {
    demoFree: "Démo (Gratuit)",
    user: ["utilisateur", "utilisateurs"],
    connection: ["connexion", "connexions"],
  },
  it: {
    demoFree: "Demo (Gratis)",
    user: ["utente", "utenti"],
    connection: ["connessione", "connessioni"],
  },
};

const getBaseLang = (lng) => {
  const l = String(lng || "").toLowerCase();
  if (l.startsWith("pt")) return "pt";
  if (l.startsWith("en")) return "en";
  if (l.startsWith("fr")) return "fr";
  if (l.startsWith("it")) return "it";
  return "es";
};

const pluralize = (forms, n) => (Number(n) === 1 ? forms[0] : forms[1]);

export function formatPlanDisplayName(plan, lng) {
  if (!plan) return "-";

  const rawName = String(plan?.name || plan?.planName || plan?.key || "").trim();
  const key = String(plan?.key || "").trim().toLowerCase();

  const users = Number(plan?.users);
  const connections = Number(plan?.connections);

  const tierFromName = (() => {
    const m = rawName.match(/^(free|starter|business|enterprise)\b/i);
    return m ? m[1].toLowerCase() : "";
  })();

  const tierKey = key || tierFromName;

  const lang = getBaseLang(lng);
  const dict = PLAN_I18N[lang] || PLAN_I18N.es;

  const nameLower = rawName.toLowerCase();
  const tierLabel =
    tierKey === "free"
      ? dict.demoFree
      : tierKey === "starter" || nameLower === "inicio"
      ? "Inicio"
      : tierKey === "business" || nameLower === "profesional"
      ? "Profesional"
      : tierKey === "enterprise" || nameLower === "enterprise"
      ? "Enterprise"
      : nameLower === "negocios"
      ? "Negocios"
      : "";

  const uOk = Number.isFinite(users) && users > 0;
  const cOk = Number.isFinite(connections) && connections > 0;

  if (tierLabel && (uOk || cOk)) {
    const parts = [];
    if (uOk) parts.push(`${users} ${pluralize(dict.user, users)}`);
    if (cOk) parts.push(`${connections} ${pluralize(dict.connection, connections)}`);
    return `${tierLabel} - ${parts.join(" / ")}`;
  }

  return rawName || "-";
}
